import { render, staticRenderFns } from "./SubmissionSpinner.vue?vue&type=template&id=861f3f30&scoped=true&"
import script from "./SubmissionSpinner.vue?vue&type=script&lang=js&"
export * from "./SubmissionSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionSpinner.vue?vue&type=style&index=0&id=861f3f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861f3f30",
  null
  
)

export default component.exports